<template>
  <div style="
  display: grid;
  grid-template-columns: 1fr 15em;
  grid-auto-rows: auto;
  gap: 10px;
" v-if="$GLOBAL_DATA.user['degree'] == 4">
    <div class="chart-humans-box rounded-lg container">
      <h2 class="text-center mb-3">نمودار عملکرد پرسنل</h2>
      <Bar
          v-if="chartData.labels.length > 0"
          id="my-chart-id"
          :options="chartOptions"
          :data="chartData"
          style="max-width: 100%;"
      />

    </div>

    <OnlineUsers />

    <div class="last-changes rounded-lg container" >
      <h2 class="text-center mb-3">آخرین تغیرات ثبت شده</h2>
      <v-data-table
          dense
          hide-default-footer
          :loading="loading_reports"
          :headers="last_changes.headers"
          :items="last_changes.desserts"
          class="elevation-0"
      >
        <template v-slot:item.des="{ item }">
          <v-tooltip v-if="item.des.length>100" top color="gray" max-width="50em">
            <template v-slot:activator="{ on, attrs }">
              <div v-bind="attrs"
                   v-on="on">
                {{item.des.slice(0,50)+'...'}}
              </div>
            </template>
            <span>{{item.des}}</span>
          </v-tooltip>
          <div v-else>
            {{item.des}}
          </div>
        </template>
        <template v-slot:item.created_at="{ item }">
          <v-tooltip top color="red">
            <template v-slot:activator="{ on, attrs }">
              <a v-bind="attrs"
                 v-on="on">
                {{new Date(item.created_at.split('T')[0]).toLocaleDateString('fa-IR')}}
              </a>
            </template>
            <span>{{ convert_en_to_fa_number(item.created_at.split('T')[1].split('.')[0]) }}</span>
          </v-tooltip>
        </template>
        <template v-slot:item.created_by="{ item }">
          <v-row>
            <v-col class="text-left my-3">
              <v-avatar v-if="item['created_by']">
                <v-img class=" " v-if="item['created_by']['profile_picture']"  max-width="35px" height="35px"
                       :src="item['created_by']['profile_picture']"></v-img>
                <v-icon v-else size="40">mdi-account-circle</v-icon>
              </v-avatar>
            </v-col>
            <v-col class="text-right my-6">
              <div >
                {{ item["created_by"]["get_full_name"] }}
              </div>
            </v-col>
          </v-row>
        </template>
      </v-data-table>
    </div>
  </div>
  <div v-else>
    <v-row>
      <v-col cols="12" md="3" sm="6" xs="12" v-for="card in reportsCard" :key="card.color ">
        <v-card class="mx-auto" outlined dark :color="card.color ">
          <v-list-item three-line>
            <v-list-item-content>
              <v-list-item-title class=" text-white yekan-font mb-1">
                <h2>{{ card.name }}</h2>
              </v-list-item-title>
              <v-list-item-subtitle >{{ card.value }}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-card-actions @click="$emit('change_nav', card.link)" class="text-center" style="padding:0;margin:-0.025em;">
            <v-hover
                v-slot="{ hover }">
              <v-btn text dark block style="background:rgba(0,0,0,0.2);border-radius:0 0 4px 4px;">
                بیشتر
                <v-icon style="transition: all 0.3s;" :class="hover?'mr-5':'mr-1'">mdi-arrow-left</v-icon>
              </v-btn>
            </v-hover>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import axios from "axios";
import { Bar } from 'vue-chartjs'
import { Chart as ChartJS, Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale } from 'chart.js'
import OnlineUsers from "@/components/admin/dashboard/online_users.vue";

ChartJS.register(Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale)
export default {
  name: "HomeDashboard",
  components:{OnlineUsers, Bar},
  props:['user'],
  data:()=>({
    key: localStorage.getItem('key'),
    reportsCard: [{
      name: "گزارش ثبت شده",
      color: "#17A2B8",
      value: "-",
      link: 3
    },
      {
        name: "لیست کارهای من",
        color: "#28A745",
        value: "-",
        link: 2
      },
      {
        name: "بارکد خوان",
        color: "#FFC107",
        value: "-",
        link: 4
      },
      {
        name: "ثبت تیکت",
        color: "#DC3545",
        value: "-",
        link: 5
      },
    ],
    chartData: {
      labels: [],
      datasets: [{
        data: [],
        label: 'عملکرد ',
        backgroundColor: '#aae7e2',
      }]
    },
    chartOptions: {
      responsive: true
    },
    last_changes: {
      headers: [
        {text: 'شماره',sortable: false,align: 'center', value: 'id',},
        {text: 'شرح',sortable: false,align: 'center', value: 'des'},
        {text: 'پرسنل',align: 'center', value: 'created_by'},
        {text: 'تاریخ',align: 'center', value: 'created_at'},
      ],
      desserts: [],
    },
    search_online_users_field:null,
    loading_reports:false,
    reports:[],
  }),
  created() {
    this.get_last_reports();
    //
    if (this.$GLOBAL_DATA.user['degree'] > 3){
      this.get_reports_chart_users();
    }
  },
  methods:{
    get_reports_chart_users(){
      axios
        .get(this.BACKEND_LINK + '/api/reports/user-count/', {
          headers: {'Authorization': `Token ${this.key}`}
        }).then((response)=>{
          for(let i=0;i < response.data.length;i++){
            let user = response.data[i];
            this.chartData.labels.push(user["get_full_name"])
            this.chartData.datasets[0].data.push(user.reports_count);
          }
        }).catch(()=>{
          this.$snotify.error('خطا در دریافت نمودار آنلاین')
        });
    },
    get_last_reports(){
      this.loading_reports=true;
      axios.get(this.BACKEND_LINK + '/api/reports/?page=1',{
        headers: {'Authorization': `Token ${this.key}`}
      }).then((response)=>{
        this.last_changes.desserts = response.data.results;
        this.loading_reports=false;
      }).catch(()=>{
        this.$snotify.error('خطا در دریافت گزارشها.');
        this.loading_reports=false;
      })
    },

  }
}
</script>

<style scoped>

</style>
